import { useEffect } from 'react';

export const useOrderEffects = (step, watchSameAsBilling, watchBillingAddress, setValue) => {
  // Add scrollbar hide styles
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .scrollbar-hide {
        -ms-overflow-style: none;
        scrollbar-width: none;
      }
      .scrollbar-hide::-webkit-scrollbar {
        display: none;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Scroll to top when customer details or summary step is active
  useEffect(() => {
    if (step === 'customer' || step === 'summary') {
      window.scrollTo(0, 0);
    }
  }, [step]);

  // Auto-sync shipping address with billing address
  useEffect(() => {
    if (watchSameAsBilling && watchBillingAddress) {
      setValue('shippingAddress', watchBillingAddress);
    }
  }, [watchBillingAddress, watchSameAsBilling, setValue]);
};
